import React, { useEffect, useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';

import UserDetailsCard from '../components/UserDetailsCard';
import ModuleAccessTable from '../components/ModuleAccessTable';
import NotificationsSection from '../components/NotificationsSection';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import BackButton from '../../../sharedModules/layout/BackButton';

import { UsersContext } from '../contexts/UsersContext';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const UserEdit: React.FunctionComponent = () => {
  const { userId } = useParams<Record<string, string>>();
  const history = useHistory();
  const { user: currentUser } = useContext(AuthenticationContext);
  const { user, fetchUser, userLoading } = useContext(UsersContext);

  const hasAdminModule = currentUser?.modules?.some((module) => module.value === 'admin' && parseInt(module.tier) > 2);

  useEffect(() => {
    if (!hasAdminModule) {
      history.push('/');
      return;
    }
    fetchUser(userId);
  }, [userId, hasAdminModule, history]);

  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={3}>
        <BackButton buttonLabel="User List" buttonLink={'/admin/user_management'} />
      </Grid>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={userLoading}>
          <Typography variant="h4" component="h5">
            {`${user.first_name} ${user.last_name}`}
          </Typography>
          <table style={{ borderCollapse: 'collapse', marginTop: 4 }}>
            <tbody>
              <tr>
                <td style={{ paddingRight: 12, verticalAlign: 'top' }}>
                  <Typography variant="h5" component="span" style={{ color: 'dimgray', fontWeight: 'bold' }}>
                    Microsoft ID
                  </Typography>
                </td>
                <td>
                  <Typography variant="h5" component="span" style={{ color: 'dimgray' }}>
                    {user.email}
                  </Typography>
                </td>
              </tr>
              <tr>
                <td style={{ paddingRight: 12, verticalAlign: 'top' }}>
                  <Typography variant="h5" component="span" style={{ color: 'dimgray', fontWeight: 'bold' }}>
                    XOI ID
                  </Typography>
                </td>
                <td>
                  <Typography variant="h5" component="span" style={{ color: 'dimgray' }}>
                    {user.xoi_id}
                  </Typography>
                </td>
              </tr>
            </tbody>
          </table>
        </LoadingWrapper>
      </Grid>
      <Grid item xs={12}>
        <UserDetailsCard userId={userId} />
      </Grid>
      <Grid item xs={12}>
        <ModuleAccessTable userId={userId} initialRoleName={user?.role_name} />
      </Grid>
      <Grid item xs={12}>
        <NotificationsSection />
      </Grid>
    </Grid>
  );
};

export default UserEdit;
